// src/components/Sidebar.js
import React from "react";
import SidebarItem from "./SidebarItem";
import {
  Home,
  Users,
  Clock,
  FileText,
  BarChart2,
  RefreshCw,
  HelpCircle,
} from "lucide-react"; // Import the User icon
import Logo from "../logo.svg"; // Adjust if it's in a subfolder
import { toast } from "react-toastify";

const Sidebar = ({ activePage, setActivePage }) => {
  const handleResetDemoData = () => {
    if (
      window.confirm(
        "Are you sure you want to reset the demo data? This action cannot be undone."
      )
    ) {
      localStorage.clear();
      localStorage.setItem("showResetToast", "true");
      window.location.reload();
    }
  };

  React.useEffect(() => {
    const showResetToast = localStorage.getItem("showResetToast");
    if (showResetToast) {
      localStorage.removeItem("showResetToast");
      setTimeout(() => {
        toast.success("Demo data has been reset");
      }, 100);
    }
  }, []);

  return (
    <div className="w-full md:w-64 bg-white flex flex-col border-b md:border-b-0 md:border-r">
      <nav className="mt-8 md:mt-16">
        {[
          { label: "Overview", icon: Home },
          { label: "Students", icon: Users },
          { label: "Opportunities", icon: FileText },
          { label: "Time Logs", icon: Clock },
          { label: "Reports", icon: BarChart2 },
        ].map((item) => (
          <SidebarItem
            key={item.label}
            Icon={item.icon}
            label={item.label}
            active={activePage === item.label}
            onClick={() => setActivePage(item.label)}
          />
        ))}
      </nav>
      <div className="flex flex-col gap-4 p-4">
        <button
          onClick={handleResetDemoData}
          className="w-full py-2 px-4 btn btn-outline  bg-white text-red-500 border border-red-500 rounded-md hover:bg-red-600 hover:text-white transition-colors duration-200 flex items-center justify-center text-sm"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Reset Demo Data
        </button>
      </div>
      <div className="mt-auto">
        <div className="p-4 border-t border-b">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium">
              DU
            </div>
            <div>
              <div className="font-medium">Demo User</div>
              <div className="text-sm text-gray-500">demo@wbltracker.com</div>
            </div>
          </div>
        </div>
        <div className="p-4 border-b">
          <a
            href="mailto:hello@wbltracker.com"
            className="text-sm text-gray-600 hover:text-gray-800 flex items-center justify-center gap-2"
          >
            <HelpCircle size={16} />
            Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
